export const EMAIL_PLUGIN_ENDPOINT = "/v1/admin/plugins/email";

// Statuses for the FTP and S3 cards come from the connections those pages already manage.
export const FTP_ENDPOINT = "/v1/admin/ftp-connections";
export const STORAGE_ENDPOINT = "/v1/admin/storage";
